import { BackstageConfig } from '@softwareimaging/backstage';

export enum Environment {
  Development = 'development',
  Production = 'production'
}

export interface Config extends BackstageConfig {
  variables: {
    graphDriveId: string;
    sharedResourceFolderId: string;
    graphBaseUrl: string;
    listId: string;
    siteId: string;
    mspsFolderId: string;
    listDeploymentMetadata: string;

    cmsBaseUrl: string;
    clientId: string;
    signInPolicy: string;
    signUpPolicy: string;
    claimEnvironment: Environment;
    appInsightsConnectionString: string;
    apiClientId: string;
    authority: string;
    apiScope: string;
    tenant: string;
    apiBaseUrl: string;
    imageBaseUrl: string;
    supportEmail: string;
    logosBaseUrl: string;

    intercomAppId: string;
    loqateApiKey: string;
  };
}

export type Variables = keyof Config['variables'];
export type Flags = keyof Config['flags'];
